import { getApiUrl } from "../config"
import queryString from "query-string"
import get from 'lodash/get'
import compact from 'lodash/compact'
import first from 'lodash/first'
import endsWith from 'lodash/endsWith'
import {genderEmpty} from "../utils/gender"
import {BASE_URL} from '../config'
import {canUseDom} from '../utils/dom'

function checkStatus(response) {
    const { status, statusText } = response;

    if (status >= 200 && status < 300) return response;

    const error = new Error(statusText);
    error.response = response;
    throw error;
}

function checkAddToBagStatus(response) {
    const { status, statusText } = response;

    // For some reason i get a 302 when i add to the cart
    if (status >= 200 && status < 303) return response;

    const error = new Error(statusText);
    error.response = response;
    throw error;
}


function checkJson(json) {
    const { error } = json;
    if( error ) throw new Error(error.stack ? error.stack : error);
    return json
}

export const fetchContent = async (path, query) => {
    let apiPath = ! path || path === "" || path === "/" ? "/today" : path;
    let url = getApiUrl().toString() + apiPath;

    if(query)
    {
        var stringifyQuery = queryString.stringify(query);
        if(stringifyQuery)
            url += `?${stringifyQuery}`;
    }

    return fetch( url, {
        headers: {
            Accept: 'application/json',
            ...(!canUseDom ? { 'X-Edition-SSR-Internal': 'true' } : {}),
        },
        credentials: 'include'
    })
    .then(checkStatus)
    .then(data => data.json())
    .then(checkJson)
}

export const fetchEveJsonData = async (url, token, method='GET') => {
    return fetch( url, {
        method: method,
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        //credentials: 'include'
    })
        .then(checkStatus)
        .then(data => data.json())
}

export const postEveJsonData = async (url, token, body, method='POST', credentials=undefined) => {
    return fetch( url, {
        method: method,
        body: body,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            Accept: 'application/json, application/xml, text/plain, text/html, *.*',
            Authorization: `Bearer ${token}`
        },
        credentials: credentials
    })
        .then(checkStatus)
        .then(data => data.json())
}

export const postEveAddToBagJsonData = async (url, token, body, method='POST', credentials=undefined) => {
    return fetch( url, {
        method: method,
        body: body,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            Accept: 'application/json, text/plain, */*',
            'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: credentials
    })
    .then(checkAddToBagStatus)
    .then(data => data.json())
}


export const fetchGlobalContent = async (query) => {
    return fetchContent('/global', query)
}


export const getSearchContent = async (dispatch, getState) => {

    const { location, experiments } = getState()
    const pageContent = await fetchContent("/search", { ...location.query, ref: experiments.ref });
    return pageContent
}

export const getTodayContent = async (getState) => {
    const { location, experiments } = getState()
    return await fetchContent("/today", { ...location.query, ref: experiments.ref });
}

export const getArticleContent = async (dispatch, getState, globalContent) => {

    const { location, content, experiments } = getState()
    let apiPath = location.pathname.replace(BASE_URL, '');
    const gender = content.gender && content.gender.toLowerCase() !== genderEmpty ? content.gender : undefined;

    const item = first(globalContent.menu.filter(item => item.url === apiPath));
    const categories = globalContent.categories;
    
    const pathSegment = first(compact(apiPath.split('/')))
    const category = first(categories.filter(cat => pathSegment !== cat.uid && endsWith(pathSegment, `-${cat.uid}`)));
    if( !item && category ) {
        const categorySuffix = `-${category.uid}`;
        apiPath = `/article${apiPath.replace(pathSegment, () => pathSegment.slice(0, -categorySuffix.length))}`;
    } else {
        apiPath = `/articles${apiPath}`;
    }
    return await fetchContent(apiPath, { ...location.query, g: gender, category: get( category, ['uid'] ), ref: experiments.ref } );
}

export const getUserMetadata = async () => {
    return await fetchContent('/user/metadata');
}



// WEBPACK FOOTER //
// ./src/api/index.js